module.exports = __webpack_public_path__ + "img/empty-box-small.61c20dab.png";